import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Observable } from 'rxjs';

import { InviteBulkUsersResponse, UsersToInvite } from 'projects/shared/services/inspection-companies/inspection-company.user.service';
import { ExpectedError, HttpErrorResponse } from 'projects/shared/services/models/error.response';

@Component({
  selector: 'shared-invite-users-bulk-form',
  standalone: false,
  styles: [
    `
      @use '../../../component-library/styles/colors.scss' as colors;

      .upload-modal-info {
        display: flex;
      }

      .upload-modal-info a {
        margin-left: auto;
      }

      .cancel {
        display: flex;
      }

      .cancelButton {
        margin-left: auto;
      }
    `,
  ],
  template: `
    <form class="company-form">
      <nz-form-control [nzXs]="24">
        <span class="upload-modal-info"
          >{{ 'Portal.InspectionCompanies.Activate.Form.UploadMultipleUsers' | translate }}
          <a (click)="downloadBulkExample()">{{ 'Portal.InspectionCompanies.Activate.Form.Bulk.DownloadTemplate' | translate }}</a>
        </span>
      </nz-form-control>

      <app-alert type="error" *ngIf="errors" [errorKeys]="errors"></app-alert>
      <mac-form-input-file [accept]="['Csv']" [fixedHeight]="154" [isLoading]="isLoading" [fileType]="'file'" (fileChange)="onFileSelected($event)">
      </mac-form-input-file>
      <div class="cancel">
        <mac-modal-cancel-button class="cancelButton" (cancel)="cancel()" />
      </div>
    </form>
  `,
})
export class InviteUsersBulkFormComponent {
  @Input() bulkInviteUsersAction: (file: File) => Observable<InviteBulkUsersResponse>;

  @Output() usersInvited = new EventEmitter<void>();
  @Output() cancelling = new EventEmitter<void>();

  errors: ExpectedError[] = [];
  isLoading = false;

  constructor(private nzNotificationService: NzNotificationService, private translateService: TranslateService) {}

  onFileSelected(file: File) {
    this.errors = [];
    if (file.name.split('.').pop()?.toLowerCase() === 'csv') {
      this.isLoading = true;
      this.bulkInviteUsersAction(file).subscribe({
        next: (response: InviteBulkUsersResponse) => {
          if (response.errorCount === 0) {
            this.nzNotificationService.success(
              '',
              this.translateService.instant('Portal.InspectionCompanies.Users.All.BulkInviteUsers.Success.Message', { COUNT: response.successCount }),
              { nzPlacement: 'bottom' }
            );
          } else {
            this.nzNotificationService.error(
              '',
              this.translateService.instant('Portal.InspectionCompanies.Users.All.BulkInviteUsers.Error.Message', {
                SUCCESSCOUNT: response.successCount,
                ERRORCOUNT: response.errorCount,
              }),
              { nzDuration: 0, nzPlacement: 'bottom' }
            );
            // open file in response.file
            this.downloadFile(response.errorList);
          }
          this.isLoading = false;
          this.usersInvited.emit();
        },
        error: (response: HttpErrorResponse) => {
          this.errors = response.error.errors;
          this.isLoading = false;
        },
      });
    } else {
      this.errors = ['FILE_NOT_IN_CORRECT_FORMAT'];
    }
  }

  downloadBulkExample() {
    const file = new Blob(['Email;Roles\ndavid@vti.com;Inspector,Editor'], { type: 'text/csv' });
    const data = window.URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = data;
    link.download = 'invite-users.csv'; // set a name for the file
    link.click();
  }

  downloadFile(errorList: UsersToInvite[]) {
    const file = new Blob(
      [
        'Email;Roles\n'.concat(
          errorList
            .map(
              (user) =>
                `${user.email};${user.roles.join(', ')};${this.translateService.instant(
                  'Portal.InspectionCompanies.Users.All.BulkInviteUser.Error.'.concat(user.error)
                )}\n`
            )
            .join('')
        ),
      ],
      { type: 'text/csv' }
    );
    const data = window.URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = data;
    link.download = 'invite-users.csv'; // set a name for the file
    link.click();
  }

  cancel() {
    this.cancelling.emit();
  }
}
